import { maskitoNumberOptionsGenerator, maskitoCaretGuard, maskitoDateTimeOptionsGenerator, maskitoDateOptionsGenerator } from "@maskito/kit";
import { I18n } from "app-core";
let toRegexArr = () => [];
function createElementPredicate() {
  return (el) => {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
          resolve(el);
          return;
        }
        resolve(el.querySelector("input, textarea"));
      });
    });
  };
}
const receiptReferenceNumberMask = () => {
  const mask = toRegexArr("mask.receiptReferenceNumber");
  const elementPredicate = createElementPredicate();
  if (!mask.length) return { elementPredicate };
  return { mask, elementPredicate };
};
const hashMask = () => {
  return {
    mask: [/[A-Za-z]/, /[A-Za-z]/, /\d/, /\d/, /\d/, /[A-Za-z]/, /[A-Za-z]/, /\d/, /\d/, /\d/],
    elementPredicate: createElementPredicate()
  };
};
const ipAddressMask = () => {
  return {
    mask: [/[A-Za-z]/, /[A-Za-z]/, /\d/, /\d/, /\d/, /[A-Za-z]/, /[A-Za-z]/, /\d/, /\d/, /\d/],
    elementPredicate: createElementPredicate()
  };
};
const buyerCostCenterMask = () => {
  const mask = toRegexArr("mask.buyerCostCenter");
  const elementPredicate = createElementPredicate();
  if (!mask.length) return { elementPredicate };
  return { mask, elementPredicate };
};
const taxIdNumberMask = () => {
  const mask = toRegexArr("mask.taxIdNumber");
  const elementPredicate = createElementPredicate();
  if (!mask.length) return { elementPredicate };
  return { mask, elementPredicate };
};
const taxIdNumberJbkjsMask = () => {
  const mask = toRegexArr("mask.taxIdNumberJbkjs");
  const elementPredicate = createElementPredicate();
  if (!mask.length) return { elementPredicate };
  return { mask, elementPredicate };
};
const personalIdNumberMask = () => {
  const mask = toRegexArr("mask.personalIdNumber");
  const elementPredicate = createElementPredicate();
  if (!mask.length) return { elementPredicate };
  return { mask, elementPredicate };
};
const emptyMask = () => ({ elementPredicate: createElementPredicate() });
const timeMask = () => ({
  mask: [/\d/, /\d/, ":", /\d/, /\d/, ":", /\d/, /\d/],
  elementPredicate: createElementPredicate()
});
const createDateMask = (options) => {
  const { dateFormat, min, max } = options;
  let separator = "/";
  if (dateFormat.includes(".")) separator = ".";
  else if (dateFormat.includes("-")) separator = "-";
  let format = dateFormat.toLowerCase();
  if (format[format.length - 1] === separator) format = format.slice(0, -1);
  const mode = format.replace(new RegExp("\\" + separator, "g"), "/");
  const maskitoOptions = maskitoDateOptionsGenerator({
    mode,
    separator,
    min: min ? new Date(min) : void 0,
    max: max ? new Date(max) : void 0
  });
  const mask = {
    ...maskitoOptions,
    elementPredicate: createElementPredicate()
  };
  return mask;
};
const createDateTimeMask = (options) => {
  const { dateFormat, timeFormat, min, max } = options;
  let separator = "/";
  if (dateFormat.includes(".")) separator = ".";
  else if (dateFormat.includes("-")) separator = "-";
  let format = dateFormat.toLowerCase();
  if (format[format.length - 1] === separator) format = format.slice(0, -1);
  const dateMode = format.replace(new RegExp("\\" + separator, "g"), "/");
  const timeMode = timeFormat || "HH:MM";
  const maskitoOptions = maskitoDateTimeOptionsGenerator({
    dateMode,
    timeMode,
    dateSeparator: separator,
    dateTimeSeparator: ". ",
    min: min ? new Date(min) : void 0,
    max: max ? new Date(max) : void 0
  });
  const mask = {
    ...maskitoOptions,
    elementPredicate: createElementPredicate()
  };
  return mask;
};
const createNumberMask = (options) => {
  const { precision, prefix, postfix, min, max } = options;
  let { plugins, ...numberOptions } = maskitoNumberOptionsGenerator({
    postfix,
    prefix,
    min,
    max,
    precision,
    decimalSeparator: ".",
    thousandSeparator: "",
    // Maskito's default minus is U+2212, which parseFloat/Number read as NaN.
    minusSign: "-"
  });
  if (postfix) {
    plugins = [...plugins, maskitoCaretGuard((value) => [0, value.length - 1])];
  }
  const maskitoOptions = {
    ...numberOptions,
    plugins
  };
  const mask = {
    ...maskitoOptions,
    elementPredicate: createElementPredicate()
  };
  return mask;
};
function useNumberMask() {
  return { createNumberMask };
}
function useMaskito() {
  toRegexArr = (str) => {
    const regArr = I18n.c(str);
    return regArr.map((i) => new RegExp(i.replace(/\\\\/g, "\\")));
  };
  return {
    createDateMask,
    createDateTimeMask,
    createNumberMask,
    hashMask,
    timeMask,
    ipAddressMask,
    receiptReferenceNumberMask,
    buyerCostCenterMask,
    taxIdNumberMask,
    taxIdNumberJbkjsMask,
    personalIdNumberMask,
    emptyMask
  };
}
export {
  useMaskito,
  useNumberMask
};
//# sourceMappingURL=index51.js.map
